import { createStore } from 'vuex'
import { showSuccess, showError } from '../utils/globalFunctions'

import rootMutations from './mutations.js'
import rootActions from './actions.js'
import rootGetters from './getters.js'

import homeModule from './modules/home/index.js'
import footerModule from './modules/footer/index.js'
import navbarModule from './modules/navbar/index.js'

import aboutModule from './modules/about/index.js'
import newsModule from './modules/news/index.js'
import facilitiesModule from './modules/devices-ultilities/index.js'
import recruitModule from './modules/recruit/index.js'
import forStudentModule from './modules/for-student/index.js'
import webStructureModule from './modules/web-structure/index.js'
import trainingServicesModule from './modules/training-services/index.js'
import noInfoModule from './modules/no-info/index.js'
import mediaModule from './modules/media/index.js'
import userModule from './modules/users/index.js'
import roleModule from './modules/roles/index.js'
import permissionModule from './modules/permissions/index.js'
import authorizeModule from './modules/authorize/index.js'
import documentModule from './modules/documents/index.js'
import groupPermission from './modules/groupPermission'
import questionModule from './modules/question'
import layoutAdjustmentModule from './modules/layout-adjustments'
import contactModule from './modules/contact'
import backgrondColorModule from './modules/backgrond-colors'
import subscriptionModule from './modules/subscription/index.js'

const store = createStore({
  modules: {
    home: homeModule,
    footer: footerModule,
    navbar: navbarModule,
    about: aboutModule,
    news: newsModule,
    facilities: facilitiesModule,
    recruit: recruitModule,
    student: forStudentModule,
    web: webStructureModule,
    services: trainingServicesModule,
    media: mediaModule,
    users: userModule,
    roles: roleModule,
    permissions: permissionModule,
    authorize: authorizeModule,
    documents: documentModule,
    noInfo: noInfoModule,
    groupPermission: groupPermission,
    question: questionModule,
    layout: layoutAdjustmentModule,
    contact: contactModule,
    color: backgrondColorModule,
    sub: subscriptionModule
  },
  state () {
    return {
      lang: 'vn',
      isLoggedIn: false,
      isTrainee: false,
      hasData: false,
      userId: 0,
      userRoles: [],
      userPermissions: [],
      userPermissionNames: [],
      username: '',
      email: '',
      API_Url: '/api/',
      Img_Url: '/',
      token: null,
      authAxios: null
    }
  },
  mutations: rootMutations,
  actions: rootActions,
  getters: rootGetters
})

store.subscribe((mutation, state) => {
  // const data = JSON.stringify(state);
  const newState = {
    lang: state.lang,
    isLoggedIn: state.isLoggedIn,
    isTrainee: state.isTrainee,
    hasData: false,
    userId: state.userId,
    userRoles: state.userRoles,
    userPermissions: state.userPermissions,
    userPermissionNames: state.userPermissionNames,
    username: state.username,
    email: state.email,
    API_Url: '/api/',
    Img_Url: '/',
    token: state.token
  }
  // console.log(`Data state : ` + data);
  localStorage.clear()
  localStorage.setItem('storeLocal', JSON.stringify(newState))
})
// store.subscribe((mutation, state) => {
//   localStorage.clear()
//   localStorage.setItem('storeLocal', JSON.stringify(state))
// })

export default store
export { showSuccess, showError }
